import { useEffect, useState } from "react";

import {
  getPhilipsPdcState,
  isPhilipsPdcExtensionAvailable,
  subscribePhilipsPdcState,
} from "./philipsPdcConnectionState";

/**
 * Tracks Philips Device Connector + SpeechMike presence for the sidebar icon.
 *
 * @returns {import("./philipsPdcConnectionState").PhilipsPdcState}
 */
export default function usePhilipsPdcPresence() {
  const [pdcState, setPdcState] = useState(() => {
    if (typeof window === "undefined") {
      return { status: "pending", deviceTypeName: null, deviceCount: 0 };
    }
    if (!isPhilipsPdcExtensionAvailable()) {
      return { status: "absent", deviceTypeName: null, deviceCount: 0 };
    }
    return getPhilipsPdcState();
  });

  useEffect(() => {
    if (typeof window === "undefined") return undefined;

    const sync = () => {
      if (!isPhilipsPdcExtensionAvailable()) {
        setPdcState({ status: "absent", deviceTypeName: null, deviceCount: 0 });
        return;
      }
      setPdcState(getPhilipsPdcState());
    };

    sync();
    return subscribePhilipsPdcState(setPdcState);
  }, []);

  return pdcState;
}
